import React from 'react'
import { Fab } from 'transfix-ui/components/Fab'
import { useBreakpointContext } from 'utils/context/BreakpointContext'
import { TopNavCTA } from 'components/layout'
import { AddIcon } from 'transfix-icons'

interface AddTrailerButtonProps {
  onClick: () => void
}

const AddTrailerButton = ({ onClick }: AddTrailerButtonProps) => {
  const { isMobile } = useBreakpointContext()

  return isMobile ? (
    <Fab aria-label='Add Trailer' onClick={onClick} color='primary' size='large'>
      <AddIcon />
    </Fab>
  ) : (
    <TopNavCTA label='Add Trailer' onClick={onClick} large />
  )
}

export default AddTrailerButton
